import { render, staticRenderFns } from "./ConfirmUnlock.vue?vue&type=template&id=545eb7a0&scoped=true&"
import script from "./ConfirmUnlock.vue?vue&type=script&lang=js&"
export * from "./ConfirmUnlock.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUnlock.vue?vue&type=style&index=0&id=545eb7a0&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=545eb7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545eb7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545eb7a0')) {
      api.createRecord('545eb7a0', component.options)
    } else {
      api.reload('545eb7a0', component.options)
    }
    module.hot.accept("./ConfirmUnlock.vue?vue&type=template&id=545eb7a0&scoped=true&", function () {
      api.rerender('545eb7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ConfirmUnlock.vue"
export default component.exports